import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBecepsRightArm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="beceps-right-arm, strong, flex, power"><path d="M12.2423 12.9014C15.0833 7.88889 21.2524 9.85207 21.25 14.7286C21.25 22.8319 7.75333 22.3211 3.05702 18.9101C1.52717 10.2147 5.95975 2.75 10.9189 2.75C15.9033 2.75 12.7974 9.66075 9.04058 6.43573" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M14.7759 13.85C12.4987 12.1412 10.2395 13.1133 8.30078 14.7752C9.56662 12 8.10609 11.0263 10.6133 7.375" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBecepsRightArm;
